import script from "./leaves-admin-apply-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./leaves-admin-apply-modal.vue?vue&type=script&setup=true&lang=js"

import "./leaves-admin-apply-modal.vue?vue&type=style&index=0&id=47014eae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47014eae"]])

export default __exports__